var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapArrow = function SvgMapArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03 4.038h6.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-4.94l-6.144 6.145a.75.75 0 0 1-1.06-1.061l6.144-6.144H6.03a.75.75 0 0 1 0-1.5Z",
    fill: "#4F4F4F"
  })));
};

export { SvgMapArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjAzMDIgNC4wMzc2NkwxMi43ODAyIDQuMDM3NjZDMTMuMTk0NCA0LjAzNzY2IDEzLjUzMDIgNC4zNzM0NSAxMy41MzAyIDQuNzg3NjZMMTMuNTMwMiAxMS41Mzc3QzEzLjUzMDIgMTEuOTUxOSAxMy4xOTQ0IDEyLjI4NzcgMTIuNzgwMiAxMi4yODc3QzEyLjM2NiAxMi4yODc3IDEyLjAzMDIgMTEuOTUxOSAxMi4wMzAyIDExLjUzNzdMMTIuMDMwMiA2LjU5ODMyTDUuODg1OTEgMTIuNzQyNkM1LjU5MzAyIDEzLjAzNTUgNS4xMTgxNSAxMy4wMzU1IDQuODI1MjUgMTIuNzQyNkM0LjUzMjM2IDEyLjQ0OTcgNC41MzIzNiAxMS45NzQ4IDQuODI1MjUgMTEuNjgyTDEwLjk2OTUgNS41Mzc2Nkw2LjAzMDIgNS41Mzc2NkM1LjYxNTk5IDUuNTM3NjYgNS4yODAyIDUuMjAxODcgNS4yODAyIDQuNzg3NjZDNS4yODAyIDQuMzczNDUgNS42MTU5OSA0LjAzNzY2IDYuMDMwMiA0LjAzNzY2WiIgZmlsbD0iIzRGNEY0RiIvPgo8L3N2Zz4K";